import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CustomerGetAction, CustomerStatusAction } from '../../Redux/Action/CustomerAction';
import { CategoryAddAction } from "../../Redux/Action/Category";
import { toast } from "react-toastify";
import { imageExtentionSupport } from "../../utils/Helper";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATION_MESSAGE } from "../../Constants/Constants";
import { useIntl, FormattedMessage } from 'react-intl';




interface FormInputs {
  image_file: string,
  name: string,
}
function CategoryAdd() {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const category = useSelector((state: any) => state.CategoryAddState);
  const navigate = useNavigate()
  const log_in = useSelector((state: any) => state.AdminLogInState)
  const [image, setImage] = useState('')
  const [imageError, setImageError] = useState('')

  const formSchema: any = Yup.object().shape({
    name: Yup.string()
      .required(intl.formatMessage({ id: 'please_enter_category_name' }))
      .trim()
      // .matches(/^[A-Za-z'\-]+(?: [A-Za-z'\-]+)*$/, 'Alphabets, hyphen and single space are valid.')
      .min(2, intl.formatMessage({ id: 'category_name_min_length' }))
      .max(50, intl.formatMessage({ id: 'category_name_max_length' })),

      image_file: Yup.mixed()
      .test("required", VALIDATION_MESSAGE?.ANY_CHOOSE + "  image ", (file : any) => {
          if (file.length == 0) { return false };
          return true;
      })
    
      .test("fileType", VALIDATION_MESSAGE?.USER_UNSUPPORTED + " Please choose an icon using .jpeg, .png, .jpg, .gif, .webp format. ", (file:any) => {
          if (file.length > 0 && file[0].type) {
              var file_type = file.length && ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(file[0].type)
              if (file_type) {
                  return file_type;
              }
              else {

                  return file_type;
              }
          }
          else {
              return true;
          }
      }),
  });

  const { register, formState: { errors }, handleSubmit, watch, setValue } = useForm<FormInputs>({
    resolver: yupResolver(formSchema),
  });
  const [categoryImage, setCategoryImage] = useState('');
  const selectFileHandler = (e: any) => {
    let bannerimage = e.target.files[0];
    setCategoryImage(bannerimage);
};
  const onSubmit = (data: FormInputs) => {
    data.image_file = categoryImage
    // console.log(data)
    dispatch(CategoryAddAction(data))
  };

  useEffect(() => {
    if (category?.data?.status) {
      navigate('/category')
    }
  }, [category])

  useEffect(() => {
    return () => {
        dispatch(CategoryAddAction('RESET'));
    }
}, [])





  return (
    <Fragment>
      {log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={intl.formatMessage({ id: 'category_add' })}
        breadcrumbs={{
          secLast: { 'link': '/category', 'name': intl.formatMessage({ id: 'category' }) },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >


          <div className="mt-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row gy-4 mb-4">
                <div className="col-md-6">
                  <label htmlFor="username" className="form-label"><FormattedMessage id="category_name" /></label>
                  <input type="text" className="form-control mb-0" id="username" placeholder={intl.formatMessage({ id: 'enter_category' })} {...register("name", {
                    required: intl.formatMessage({ id: 'please_enter_category_name' }),

                  })}
                    onInput={(e: any) => {
                      // e.target.value = e.target.value.replace(/\s/g, '');
                    }}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="name"
                    render={({ message }) => <p className="mt-1" style={{ color: 'red' }}>{message}</p>}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label"><FormattedMessage id="image" /></label>
                  <div className="input-group auth-pass-inputgroup">
                    <input
                      type="file"
                      accept="image/jpeg,image/png,image/webp"
                      className="form-control mb-0"
                      {...register('image_file', {
                        onChange: (e) => { selectFileHandler(e) }
                      })}
                    />

                  </div>
                  <p  style={{color:'red'}} className="mt-1">{errors?.image_file?.message ?? category?.error?.errors?.image_file?.message}</p>

                </div>
                <div className="col-md-2 col-sm-6 col-12">
                  <button type="submit" className="btn btn-primary waves-effect waves-light w-100"><FormattedMessage id="save" /></button>
                </div>
              </div>
              
            </form>
          </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default CategoryAdd;